import React from "react";
import { getFromStorage } from "../utils";
import { Navigate, Outlet } from "react-router";
import { ROUTES_CONSTANTS } from "../constants";

const NoAuthLayout = () => {
  const token = getFromStorage("accessToken");
  if (token) {
    return <Navigate to={ROUTES_CONSTANTS.NO_ROUTE} replace />;
  }
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default NoAuthLayout;
